import { ToastQueue } from "@react-spectrum/s2";

type ToastOptions = NonNullable<Parameters<typeof ToastQueue.positive>[1]>;

/**
 * Spectrum's ToastQueue only auto-dismisses a toast when a `timeout` is
 * passed — omitting it leaves the toast on screen until closed manually.
 * Route all toasts through here so that default is set in one place.
 */
export const DEFAULT_TOAST_TIMEOUT = 3000;

function withDefaultTimeout(options?: ToastOptions): ToastOptions {
  return { timeout: DEFAULT_TOAST_TIMEOUT, ...options };
}

export const toast = {
  positive: (message: string, options?: ToastOptions) => ToastQueue.positive(message, withDefaultTimeout(options)),
  negative: (message: string, options?: ToastOptions) => ToastQueue.negative(message, withDefaultTimeout(options)),
  info: (message: string, options?: ToastOptions) => ToastQueue.info(message, withDefaultTimeout(options)),
  neutral: (message: string, options?: ToastOptions) => ToastQueue.neutral(message, withDefaultTimeout(options)),
};
